import { useState } from "react";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import { FormField } from "../../../../components/form-field/form-field";
import { Button } from "../../../../components/inputs/button/button";
import { Input } from "../../../../components/inputs/input/input";
import { Textarea } from "../../../../components/inputs/textarea/textarea";
import { DefaultModalLayout } from "../../../../components/modal/layouts/default-modal-layout";
import EmailService, { ISendEmailArg } from "../../../../services/api/email-service";
import {rootContainer, TYPE} from "../../../../services/container/root";

import './contact-us-popup.scss';

interface IContactUsPopup {
    onCloseClicked: () => void;
}

const ContactUsPopup: React.FC<IContactUsPopup> = ({onCloseClicked}) => {  
    const [message, setMessage] = useState(''); 
    const [contactEmail, setContactEmail] = useState('');  
    const [isLoading, setIsLoading] = useState(false);  
    
    const valid = () => {
        // check that message and email are not empty
        if (message.length === 0 || contactEmail.length === 0) {
            return false;
        }

        // check that email is valid
        if (!(/\S+@\S+\.\S+/.test(contactEmail))) {
            return false;
        }

        return true;
    };

    const sendEmail = () => {
        setIsLoading(true);
        const input: ISendEmailArg = {
            message: message,
            contactEmail: contactEmail,
        }
        const emailService = rootContainer.get<EmailService>(TYPE.EmailService);
        emailService.sendEmail(input)
            .then(res => {
                onCloseClicked();
            })
            .catch(error => {
                setIsLoading(false);
                console.log('error', error);
            });
    }

    return (
        <DefaultModalLayout onCloseClicked={onCloseClicked} isCloseDisabled={isLoading}>
            <div className="contact-us-wrapper">
                <div className="contact-us-title-wrapper">
                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>
                        Subscription plans
                    </FontBody1>
                </div>
                <div className="contact-us-subtitle-wrapper">
                    <FontBody1>
                        Explain the plan you need and a sales agent will contact you
                    </FontBody1>
                </div>
                <div className="contact-us-message-wrapper">
                    <Textarea 
                        disabled={isLoading}
                        placeholder={`Enter details`} 
                        value={message}
                        onChange={v => setMessage(v)}
                    />
                </div>
                <FormField label="Your email">
                    <Input
                        disabled={isLoading}
                        type={'email'}
                        placeholder="Type your email address"
                        value={contactEmail}
                        onChange={v => setContactEmail(v)}
                        onSubmit={sendEmail}
                    />
                </FormField>
                <div className="contact-us-button-wrapper">       
                    <Button 
                        disabled={!valid()} 
                        isLoading={isLoading} 
                        hasLoader={true} 
                        onClick={sendEmail} 
                        text="Send" 
                    />
                </div>

            </div>
        </DefaultModalLayout>
    );
}

export default ContactUsPopup;